// Nouns arrive ordered by frequency, so a noun's position in the deck *is* its
// difficulty band: the first 250 are the most common words in French, the next
// 250 the ones after that, and so on. Everything here works off that position.

export const BAND_SIZE = 250;

export const bandCount = (total) => Math.ceil(total / BAND_SIZE);

export const bandOf = (deckIndex) => Math.floor(deckIndex / BAND_SIZE);

export const bandRange = (band, total) => ({
  from: band * BAND_SIZE + 1,
  to: Math.min((band + 1) * BAND_SIZE, total),
});

export const bandLabel = (band, total) => {
  const { from, to } = bandRange(band, total);
  return `${from}–${to}`;
};

export const bandIndices = (band, total) => {
  const { from, to } = bandRange(band, total);
  const indices = [];

  for (let i = from - 1; i < to; i += 1) indices.push(i);

  return indices;
};

const shuffled = (indices) => {
  const order = indices.slice();

  for (let i = order.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }

  return order;
};

// The queue is deck positions, not nouns, so the nouns prop is never copied or
// reordered and a position always maps back to its band.
export function buildQueue({ nouns, known, bands, shuffle }) {
  const enabled = new Set(bands);
  const knownWords = new Set(known);
  const queue = [];

  nouns.forEach((noun, index) => {
    if (!enabled.has(bandOf(index))) return;
    if (knownWords.has(noun.word)) return;

    queue.push(index);
  });

  return shuffle ? shuffled(queue) : queue;
}
